import { formatDurationMs } from '@/lib/formatDuration';

/**
 * Compose the secondary "detail" line for a timeline row from an event's
 * already-structured fields (kind / durationMs / detail). Numbers carry the
 * meaning; the English connective words ("stopped", "Visited") are secondary
 * and not translated in v1.
 */
export function timelineDetail(e) {
  switch (e.kind) {
    case 'stop':
      return `${formatDurationMs(e.durationMs)} stopped`;
    case 'overspeed':
      return e.durationMs > 0 ? `${e.detail} · ${formatDurationMs(e.durationMs)}` : e.detail;
    case 'geofence':
      return e.detail.replace(/:\s*/, ' ');
    case 'poi':
      return `Visited ${e.detail}`;
    case 'harsh':
    case 'alert':
    default:
      return e.detail || '';
  }
}
